module.exports = __webpack_public_path__ + "2493780ba1ff60d643dba877b0df14df.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-9.png
// module id = 1991
// module chunks = 0